import React, { useRef, useEffect, useState} from 'react';

const VisibilityChecker = ({ children, className="", offsetTop = 0, offsetBottom = 0 }) => {
  const elementRef = useRef(null);
  const [visibilityState, setVisibilityState] = useState('below'); // 'above', 'visible', 'below'
  const [isFirstScroll, setIsFirstScroll] = useState(true);

  const checkVisibility = () => {
    const element = elementRef.current;
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    //const isAbove = rect.bottom < 0;
    const isAbove = rect.bottom + offsetTop < 0;
    const isVisible = rect.top < viewportHeight && rect.bottom >= 0;
    const isBelow = rect.top >= viewportHeight + offsetBottom;

    // Determine the parent element
    const parent = element.parentElement;

    if (parent) {
      // Remove any existing state classes
      parent.classList.remove('is-above', 'is-visible', 'is-below');

      // Add the appropriate class based on visibility
      if (isAbove) {
        parent.classList.add('is-above');
        setVisibilityState('above');
      } else if (isVisible) {
        parent.classList.add('is-visible');
        setVisibilityState('visible');
      } else if (isBelow) {
        parent.classList.add('is-below');
        setVisibilityState('below');
      }
    }
  };

  useEffect(() => {
    // Set initial state to 'below'
    const element = elementRef.current;
    if (element && element.parentElement) {
      element.parentElement.classList.add('is-below');
    }

    const handleScroll = () => {
      if (isFirstScroll) {
        setIsFirstScroll(false);
      }
      checkVisibility();
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Clean up event listeners on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [isFirstScroll]); // Add isFirstScroll to dependencies

  return (
    <span ref={elementRef} className={className}>
      {children}
    </span>
  );
};

export default VisibilityChecker;